import {DrupalParagraph} from "next-drupal";
import classNames from "classnames";
import parse from "html-react-parser";
import SectionHeading from "../../organisms/section-heading";

/**
 * A simple table paragraph.
 *
 * @param paragraph
 *   The paragraph.
 * @constructor
 */
export function ParagraphTable({paragraph}: {paragraph: DrupalParagraph}) {
  const table = paragraph?.field_table_table;
  let rows = Object.keys(table?.value ?? {}).map(item => table?.value?.[item]);
  rows = rows?.length ? rows.sort((a, b) => a.weight - b.weight) : [];
  let header = rows?.length ? rows.shift() : null;

  return (
    <div>
      {table?.caption && (
        <SectionHeading title={""}>
          {parse(table?.caption)}
        </SectionHeading>
      )}
      {rows?.length ? (
        <div className="overflow-auto">
          <table className={classNames("w-full max-h-[80vh] md:max-h-none", {
            "block": !paragraph?.field_table_full_width,
            "table-auto": !paragraph?.field_table_equal_width,
            "table-fixed": paragraph?.field_table_equal_width
          })}>
            {header && (
              <thead className={classNames("sticky top-0", {
                "text-center": paragraph?.field_table_center_header
              })}>
              <tr>
                {Object.keys(header).map((i, index) => {
                  if (isNaN(parseInt(i))) return;
                  return (
                    <td key={`${paragraph.id}--thead--${i}`} className={classNames(
                      "text-white border border-gray-200 h-1 p-4 bg-primary align-text-top", {
                      "w-36": paragraph?.field_table_equal_width && (index === 0 && Object.keys(header)?.length > 1),
                      "min-w-[100px]": !paragraph?.field_table_equal_width
                    })}>
                      {parse(header[i])}
                    </td>
                  )
                })}
              </tr>
              </thead>
            )}
            <tbody className={classNames({
              "text-regular": (!paragraph?.field_table_font_size || paragraph?.field_table_font_size === "regular"),
              "text-sm": paragraph?.field_table_font_size === "small",
            })}>
            {rows.map((row, i) => {
              if (typeof row === "object") {
                return (
                  <tr key={`${paragraph.id}--tbody--${i}`} className="even:bg-gray-100 odd:bg-white">
                    {Object.keys(row).map((colKey, index) => {
                      if (colKey === "weight") return;
                      const col = row[colKey];
                      return (
                        <td key={`${paragraph.id}--${colKey}`} className={classNames(
                          "p-4 border border-gray-200 align-text-top prose", {
                            "w-36": paragraph?.field_table_equal_width && (index === 0 && Object.keys(header)?.length > 1),
                            "min-w-[100px]": !paragraph?.field_table_equal_width
                          })}>
                          {parse(col)}
                        </td>
                      )
                    })}
                  </tr>
                )
              }
            })}
            </tbody>
          </table>
        </div>
      ): <></>}
    </div>
  );
}